export enum InviteSignupProcessStepEnum {
  Identity,
  Phone,
  Sms,
  Address,
  Contract,
  Details,
  Congratulations,
}

export const inviteSignupProcessSteps = [
  InviteSignupProcessStepEnum.Identity,
  InviteSignupProcessStepEnum.Phone,
  InviteSignupProcessStepEnum.Sms,
  InviteSignupProcessStepEnum.Address,
  InviteSignupProcessStepEnum.Contract,
  InviteSignupProcessStepEnum.Details,
  InviteSignupProcessStepEnum.Congratulations,
];
